<template>
  <div class="text-center">
    <div :class="otherOptions" v-if="currentPath.includes('finish')">
      <div :class="firstText" >
        <p>¿Quieres ver otros seguros?</p>
        <p>Conócelos en nuestro sitio web.</p>
        <v-btn :class="btnFooter" block @click="redirectHome">Volver al inicio</v-btn>
      </div>
      <div :class="firstText">
        <p>Si tienes problemas, comunicate</p>
        <p>con nosotros aquí:</p>
        <v-btn :class="btnFooter" block>Atención al cliente</v-btn>
      </div>
    </div>

    <div :class="footer">
      <!-- <label class="cobertura">El riesgo de este seguro es cubierto por
      </label> -->
      <div v-if="currentPath.includes('finish')" class="text-center" style="padding-top: 0.05%;">
        <v-img  contain max-height="70px" :src="LogoSBWhite" max-width="170" style=" margin: auto;  margin-top: 2%;" />
      </div>
      <div v-else class="text-center" style="padding-top: 0.05%;">
        <v-img contain max-height="70px" :src="LogoSB" max-width="170" style=" margin: auto;  margin-top: 2%;" />
      </div>
    </div>
  </div>
</template>

<script>
import LogoSB from "@/assets/images/LogoFooter.svg";
import LogoSBWhite from "@/assets/images/LogoFooterWhite.svg";

export default {
  name: "Footer",
  methods: {
    redirectHome(){
      // console.log('back');
      this.$router.push('/ap/');
    }
  },
  data: () => ({
    LogoSB,
    LogoSBWhite,
    footer: null,
    otherOptions: null,
    currentPath: window.location.pathname,
    screen: window.screen.width,
    firstText: null,
    btnFooter: null,
  }),
  mounted() {
    // console.log('currentPath: ', this.currentPath);
    if (this.currentPath.includes("finish")) {
      this.footer = "footer-finish";
    } else {
      this.footer = "footer";
    }

    if (this.screen > 800) {
      this.otherOptions = 'otherOptions';
      this.firstText = 'firstText';
      this.btnFooter = 'btnFooter';
    } else {
      this.otherOptions = 'otherOptions2';
      this.firstText = 'firstText2';
      this.btnFooter = 'btnFooter2';
    }
  },
  
};
</script>

<style lang="scss" scoped>
@import url("../styles/main.scss");
.firstText{
  padding-top: 2%;
  padding-bottom: 2%;
}
.firstText2{
  padding-top: 6%;
  padding-bottom: 2%;
}
.cobertura {
  font-family: Helvetica;
  font-style: normal;
  text-align: center;
  font-size: 15px;
  font-weight: 550;
  color: #232323;
  line-height: 16px;
  opacity: 0.75;
}
.footer-finish {
  height: 70px;
  background-color: #2A3881;

}

.footer {
  height: 120px;
}
.otherOptions{
  background-color: #E3E9FD;
  display: flex;
  justify-content: center;
  gap: 12%;

  p{
    font-family: Helvetica; 
    font-style: normal; 
    font-weight: 400; 
    font-size: 14px; 
    line-height: 8px; 
    letter-spacing: -0.01em;
    color: #333333;
  }
}
.otherOptions2{
  background-color: #E3E9FD;
  // display: flex;
  justify-content: center;
  gap: 12%;

  p{
    font-family: Helvetica; 
    font-style: normal; 
    font-weight: 400; 
    font-size: 14px; 
    line-height: 8px; 
    letter-spacing: -0.01em;
    color: #333333;
  }
}
.btnFooter{
    background-color: #2D387C !important; 
    color: white !important;
    border-radius: 24px;  
    max-width: 400px !important;
    font-family: Helvetica !important;
    font-style: normal !important;
    font-weight: 600 !important;
    text-transform: none;
    letter-spacing: 0.01px;
}
.btnFooter2{
    background-color: transparent !important; 
    color: #2A3881 !important;
    max-width: 400px !important;
    font-family: Helvetica !important;
    font-style: normal !important;
    font-weight: 600 !important;
    text-transform: none;
    letter-spacing: 0.01px;
    border: none;
    box-shadow: none;
}

@media only screen and (max-width: 767px) {
  .cobertura {
    font-family: Helvetica;
    font-style: normal;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #232323;
    line-height: 13px;
    opacity: 0.75;
  }
}


</style>